import { Injectable } from '@angular/core';
import { ErrorModel } from '@shared/models/app-state.model';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class ErrorService {
  private readonly errorMessages = new BehaviorSubject<ErrorModel[]>([]);
  readonly errorMessages$ = this.errorMessages.asObservable();
  readonly errorsShown$ = this.errorMessages.pipe(map((errors) => errors.length > 0));

  hideError(): void {
    this.errorMessages.next([]);
  }
}
